export const Share = () => import(/* webpackPrefetch: true, webpackChunkName: 'comp-share' */ '@ms/share/main.vue')
export const ShareTicket = () => import(/* webpackPrefetch: true, webpackChunkName: 'comp-share' */ 'wap/components/ShareTicket')

export const Betslip = () => import(/* webpackPrefetch: true, webpackChunkName: 'b09' */ 'wap/components/Betslip')
